import { useState } from 'react';

import { Container } from '@components/common/Container';
import { usePublicSiteSettings } from '@contexts/PublicSiteSettingsContext';
import { educationalImages } from '@services/imageService';
import { boardPhotoPublicUrl, resolveBoardPhotoCaption } from '@utils/boardPhoto';

const SECTION_DESCRIPTION =
  "In Spring 2024, a Board for Bethlehem Homeschool Group was formed. Each member is an active member of Bethlehem Baptist Church with a heart for the homeschool community and BHG's vision.";

const BOARD_MISSION =
  "We believe our foremost mission as a board is to honor Christ in word and action. Our promise to all BHG members is to strive to provide a place of joy and excitement for learning and fellowship.";

const BOARD_RESPONSIBILITIES =
  "The Board advises and approves decisions concerning registration, class schedules, tutors, special events, and supports the Director in weekly operations and disciplinary actions. The Board secures and approves the BHG Director.";

const SCRIPTURE = 'Therefore, go and make disciples of all nations.';
const SCRIPTURE_REF = 'Matthew 28:19';

export function OurBoardSection() {
  const { settings } = usePublicSiteSettings();
  const [photoLoadFailed, setPhotoLoadFailed] = useState(false);
  const hasCustomPhoto = Boolean(settings?.boardPhotoKey) && !photoLoadFailed;
  const imageSrc = hasCustomPhoto
    ? boardPhotoPublicUrl(settings?.updatedAt)
    : educationalImages.community;
  const caption = resolveBoardPhotoCaption(settings?.boardPhotoCaption);

  return (
    <section id="our-board" className="bhg-landing-section bhg-landing-our-board">
      <Container size="lg">
        <div className="bhg-landing-our-board__header">
          <h2 id="our-board-heading" className="bhg-landing-section__title">Meet Our Board</h2>
          <p className="bhg-landing-our-board__description">
            {SECTION_DESCRIPTION}
          </p>
        </div>

        <div className="bhg-landing-our-board__content">
          <div className="bhg-landing-our-board__image-wrapper">
            <img
              src={imageSrc}
              alt="BHG Board"
              className="bhg-landing-our-board__image"
              loading="lazy"
              width={800}
              height={500}
              onError={() => setPhotoLoadFailed(true)}
            />
            <p className="bhg-landing-our-board__caption">{caption}</p>
          </div>

          <div className="bhg-landing-our-board__text">
            <p className="bhg-landing-our-board__mission">{BOARD_MISSION}</p>
            <p className="bhg-landing-our-board__responsibilities">
              {BOARD_RESPONSIBILITIES}
            </p>
            <blockquote className="bhg-landing-our-board__scripture">
              &ldquo;{SCRIPTURE}&rdquo; — {SCRIPTURE_REF}
            </blockquote>
          </div>
        </div>
      </Container>
    </section>
  );
}
